/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgOutlineLayout = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M12 22H2v-6h10zm-2-2v-2H4v2zm4-2h8v2h-8zm-2-3H2V9h10zm-2-2v-2H4v2zm4-2h8v2h-8zm-2-3H2V2h10zm-2-2V4H4v2zm4-2h8v2h-8z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgOutlineLayout as OutlineLayout };
